<ng-container *ngIf="onlySVG">
    <svg [ngClass]="color" class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
</ng-container>

<ng-container *ngIf="SVGWithText">
    <section class="my-8 grid justify-center text-sm p-5">
        <div class="flex items-center">
            <svg [ngClass]="color" class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="mr-1">{{ text }}</span>
            <span class="dot-flashing">.</span>
            <span class="dot-flashing" style="animation-delay: 0.2s;">.</span>
            <span class="dot-flashing" style="animation-delay: 0.4s;">.</span>
        </div>
    </section>
</ng-container>

<ng-container *ngIf="!onlySVG && !SVGWithText">
    <div class="fixed left-0 top-0 flex h-screen w-screen md:h-full md:w-full items-center justify-center bg-white md:py-10 z-40" style="opacity: 0.3"></div>
    <section class="my-8 grid justify-center text-sm p-5">

        <div class="flex items-center">
            <svg [ngClass]="color" class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="mr-1">{{ text }}</span>
            <span class="dot-flashing">.</span>
            <span class="dot-flashing" style="animation-delay: 0.2s;">.</span>
            <span class="dot-flashing" style="animation-delay: 0.4s;">.</span>
        </div>

    </section>
</ng-container>
